import { PLANS_RECEIVED, PLANS_SAVED } from './types.js'

export default function plans(state = [], action = {}){
  switch (action.type) {
    case PLANS_RECEIVED:
    case PLANS_SAVED:
      return action.data
    default:
      return state
  }
}
